import type { FC } from 'react';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  Flex,
  DecorationLine,
  Body,
  Box,
  Col,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';

import StopDurationMapItinerary from './StopDurationMapItinerary';
import LeftContentWrapper from './LeftContentWrapper';

interface TechnicalStopOverMapItineraryProps {
  duration: number;
}

const TechnicalStopOverMapItinerary: FC<TechnicalStopOverMapItineraryProps> = ({
  duration,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex>
        <LeftContentWrapper />
        <DecorationLine decorationType="none" lineType="dashed" />
        <Flex flexDirection="column">
          <StopDurationMapItinerary duration={duration} />
          <Flex mb="big" flexDirection="row">
            <Col>
              <Glyph
                size="small"
                color="neutral.80"
                category="TimeAndDates"
                name="Time"
              />
            </Col>
            <Col>
              <Box pl="1x_small">
                <Body type="xSmall" color="neutral.80">
                  {t('flightSummary.stop.technical')}
                </Body>
              </Box>
            </Col>
          </Flex>
        </Flex>
      </Flex>
      <Flex>
        <LeftContentWrapper />
        <DecorationLine decorationType="none" lineType="dashed" />
      </Flex>
    </>
  );
};

export default TechnicalStopOverMapItinerary;
